import {Fragment} from 'react'
import {Controller} from 'react-hook-form'
import FormHelperText from '@mui/material/FormHelperText'
import {MuiOtpInput} from 'mui-one-time-password-input'

const OtpInput = ({name = 'code', control, autoFocus = false}) => (
  <Controller
    name={name}
    control={control}
    rules={{
      required: 'Code is required',
      validate: value => value.length === 6
    }}
    render={({field, fieldState}) => (
      <Fragment>
        <MuiOtpInput
          sx={{
            gap: {xs: 0.5, sm: 1},
            marginBottom: '10px',
            // Six boxes at the default field padding overflow a small phone, so the
            // padding gives way before the boxes have to.
            '& .MuiInputBase-input': {padding: {xs: '16.5px 2px', sm: '16.5px 14px'}}
          }}
          {...field}
          length={6}
          autoFocus={autoFocus}
        />
        {
          fieldState.invalid && (
            <FormHelperText error>
              {
                fieldState.error?.type === 'validate' ?
                  'OTP Invalid' :
                  fieldState.error?.message
              }
            </FormHelperText>)
        }
      </Fragment>
    )}
  />
)

export default OtpInput
